import { Auth0Client, Auth0ClientOptions } from "@auth0/auth0-spa-js";
import { Config } from "../entities/config";
import { navStateStore } from "../state/nav-state-store";

// Wrapper function for better testability
/* istanbul ignore next */
export function getAuth0Client(config: Config): Auth0Client {
  const authConfig: Auth0ClientOptions = {
    clientId: config.IDENTITY_CLIENT_ID,
    domain: config.IDENTITY_PROVIDER_URL,
    authorizationParams: {
      redirect_uri:
        config.IDENTITY_REDIRECT_URI === "SAME_ORIGIN"
          ? window.location.href
          : config.IDENTITY_REDIRECT_URI,
      audience: config.IDENTITY_AUDIENCE,
      scope: config.IDENTITY_USER_SCOPES,
    },
    ...(navStateStore.state.authOptions as unknown as Record<
      PropertyKey,
      unknown
    >),
  };

  return new Auth0Client(authConfig);
}
